import React from "react";
import ServicesSection from "../components/pinkhelp/ServicesSection";

const OurServcies = () => {
  return (
    <div>
     <div className="mt-12">
     <ServicesSection />
     </div>
    </div>
  );
};

export default OurServcies;
